// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cookie-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.cookie-banner {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.cookie-banner h2 {
  margin-top: 0;
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.cookie-banner p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.cookie-banner p a {
  color: #007bff;
  text-decoration: underline;
}

.cookie-banner p a:hover {
  color: #0056b3;
}

.cookie-buttons {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.cookie-buttons button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  flex: 1 1;
  min-width: 120px;
  transition: all 0.2s;
  font-weight: 500;
}

.cookie-buttons button:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
}

.cookie-buttons button:active:not(:disabled) {
  transform: translateY(0);
}

.cookie-buttons button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-accept {
  background: #28a745;
  color: white;
}

.btn-accept:hover:not(:disabled) {
  background: #218838;
}

.btn-reject {
  background: #dc3545;
  color: white;
}

.btn-reject:hover:not(:disabled) {
  background: #c82333;
}

.btn-customize {
  background: #6c757d;
  color: white;
}

.btn-customize:hover:not(:disabled) {
  background: #5a6268;
}

.btn-save {
  background: #007bff;
  color: white;
}

.btn-save:hover:not(:disabled) {
  background: #0056b3;
}

.btn-back {
  background: #6c757d;
  color: white;
}

.btn-back:hover:not(:disabled) {
  background: #5a6268;
}

.cookie-category {
  margin: 1.5rem 0;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #f8f9fa;
}

.cookie-category label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.cookie-category input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  flex-shrink: 0;
}

.cookie-category input[type="checkbox"]:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.cookie-category p {
  margin: 0;
  color: #666;
  font-size: 0.9rem;
  padding-left: 28px;
  line-height: 1.5;
}

.cookie-category strong {
  color: #333;
}

/* Responsive design */
@media (max-width: 640px) {
  .cookie-banner {
    padding: 1.5rem;
    width: 95%;
  }

  .cookie-banner h2 {
    font-size: 1.25rem;
  }

  .cookie-buttons {
    flex-direction: column;
  }

  .cookie-buttons button {
    width: 100%;
  }
}

/* Accessibility improvements */
.cookie-buttons button:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

.cookie-category input[type="checkbox"]:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CookieConsent/CookieConsent.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".cookie-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.cookie-banner {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.cookie-banner h2 {\n  margin-top: 0;\n  font-size: 1.5rem;\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.cookie-banner p {\n  color: #666;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.cookie-banner p a {\n  color: #007bff;\n  text-decoration: underline;\n}\n\n.cookie-banner p a:hover {\n  color: #0056b3;\n}\n\n.cookie-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.cookie-buttons button {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  flex: 1;\n  min-width: 120px;\n  transition: all 0.2s;\n  font-weight: 500;\n}\n\n.cookie-buttons button:hover:not(:disabled) {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n.cookie-buttons button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.cookie-buttons button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-accept {\n  background: #28a745;\n  color: white;\n}\n\n.btn-accept:hover:not(:disabled) {\n  background: #218838;\n}\n\n.btn-reject {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-reject:hover:not(:disabled) {\n  background: #c82333;\n}\n\n.btn-customize {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-customize:hover:not(:disabled) {\n  background: #5a6268;\n}\n\n.btn-save {\n  background: #007bff;\n  color: white;\n}\n\n.btn-save:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.btn-back {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-back:hover:not(:disabled) {\n  background: #5a6268;\n}\n\n.cookie-category {\n  margin: 1.5rem 0;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: #f8f9fa;\n}\n\n.cookie-category label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n}\n\n.cookie-category input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.cookie-category input[type=\"checkbox\"]:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.cookie-category p {\n  margin: 0;\n  color: #666;\n  font-size: 0.9rem;\n  padding-left: 28px;\n  line-height: 1.5;\n}\n\n.cookie-category strong {\n  color: #333;\n}\n\n/* Responsive design */\n@media (max-width: 640px) {\n  .cookie-banner {\n    padding: 1.5rem;\n    width: 95%;\n  }\n\n  .cookie-banner h2 {\n    font-size: 1.25rem;\n  }\n\n  .cookie-buttons {\n    flex-direction: column;\n  }\n\n  .cookie-buttons button {\n    width: 100%;\n  }\n}\n\n/* Accessibility improvements */\n.cookie-buttons button:focus {\n  outline: 2px solid #007bff;\n  outline-offset: 2px;\n}\n\n.cookie-category input[type=\"checkbox\"]:focus {\n  outline: 2px solid #007bff;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
